import React, { Component } from 'react';
import AuthService from '../../services/api/auth';
import LoadingModal from '../../components/LoadingModal';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import * as registerActions from './actions/';
import { withAlert } from 'react-alert';
import ErrorList from '../../components/ErrorList';
import { setLanguage } from '../../redux/application/actions';
import { isLightRegistrationSelector, returnToSelector, languageSelector } from '../../redux/application/selector';

class EmailVerificationScreen extends Component {
    constructor(props) {
        super(props);
        this.state = {
            code: '',
            loading: false,
            seconds: 0,
            errors: [],
        };
    }
    resend() {
        this.setState({
            seconds: window.VULOG_CONFIG.SMS_RESEND_SECONDS,
        });
        this.interval = setInterval(() => {
            if (this.state.seconds <= 0) {
                clearInterval(this.interval);
            }
            this.setState({
                seconds: this.state.seconds - 1,
            });
        }, 1000);

        this.setState({
            loading: true,
            errors: [],
        });

        AuthService.requestEmail(this.state)
            .then(response => {
                this.setState({
                    loading: false,
                });
                if (response.skip) {
                    AuthService.getAccountStatus().then(response => {
                        if (response.next === null) {
                            this.props.history.push('/status');
                        } else {
                            this.props.history.push(response.next);
                        }
                    });
                }
            })
            .catch(error => {
                if (error && error.data && error.data.message) {
                    this.setState({
                        loading: false,
                        errors: [error.data.message],
                    });
                } else {
                    this.setState({
                        loading: false,
                        errors: ['DEFAULT_ERROR_MESSAGE'],
                    });
                }
            });
    }

    verify() {
        if (
            !this.state.code ||
            (window.VULOG_CONFIG && this.state.code.length !== window.VULOG_CONFIG.EMAIL_CODE_LENGTH)
        ) {
            return this.setState({
                errors: [window.VULOG_TRANSLATE('email code invalid')],
            });
        }

        this.setState({
            errors: [],
        });

        this.setState({
            loading: true,
        });
        AuthService.validateEmail({
            code: this.state.code,
        })
            .then(() => {
                const { isLightRegistration, returnTo } = this.props;
                AuthService.getAccountStatus().then(response => {
                    if (isLightRegistration) {
                        const refreshToken = localStorage.getItem('refreshToken');
                        this.setState(
                            {
                                loading: false,
                            },
                            () => {
                                document.location = `${returnTo}?refreshToken=${refreshToken}`;
                            }
                        );
                    } else {
                        if (response.next === null) {
                            this.props.history.push('/status');
                        } else {
                            this.props.history.push(response.next);
                        }
                    }
                });
            })
            .catch(error => {
                this.setState({
                    loading: false,
                });
                if (error && error.data && error.data.message) {
                    this.setState({
                        errors: [error.data.message],
                    });
                }
            });
    }

    componentWillUnmount() {
        clearInterval(this.interval);
    }

    render() {
        return (
            <div className="container-fluid wrapper">
                <div className="d-flex flex-column full-height menu-bar-bottom">
                    <h3 className="page__title">{window.VULOG_TRANSLATE('EMAIL_VERIFICATION_TITLE')}</h3>
                    <h2 className="page__title-medium">{window.VULOG_TRANSLATE('EMAIL_VERIFICATION_SUBTITLE')}</h2>
                    <div className="f-container">
                        <ErrorList errors={[...this.state.errors].filter(e => !!e)} />
                        <div>
                            <div className="form-row mb-4">
                                <div className="col">
                                    <input
                                        type="text"
                                        inputMode="numeric"
                                        pattern="\d*"
                                        maxLength={window.VULOG_CONFIG.EMAIL_CODE_LENGTH}
                                        className="form-control"
                                        id="verification-code"
                                        autoComplete="one-time-code"
                                        value={this.state.code}
                                        onChange={e => this.setState({ code: e.target.value })}
                                    />
                                </div>
                            </div>

                            <div className="d-flex flex-row mt-auto mb-1-5rem">
                                <button
                                    disabled={this.state.seconds > 0}
                                    className="btn btn-primary btn-block"
                                    onClick={() => this.resend()}
                                >
                                    {this.state.seconds > 0
                                        ? this.state.seconds
                                        : window.VULOG_TRANSLATE('RESEND_EMAIL')}
                                </button>
                                <button className="btn btn-primary btn-block" onClick={() => this.verify()}>
                                    {window.VULOG_TRANSLATE('Next')}
                                    <i className="material-icons va-middle reg">keyboard_arrow_right</i>
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
                <LoadingModal loading={this.state.loading} />
            </div>
        );
    }
}

const mapStateToProps = state => ({
    position: state.register.position,
    language: languageSelector(state),
    isLightRegistration: isLightRegistrationSelector(state),
    returnTo: returnToSelector(state),
});
/**
 * Get actions and pass them as props to Component
 * @param dispatch
 * @returns {{}|B|N}
 */

const mapDispatchToProps = dispatch => ({
    onRegisterActions: bindActionCreators(registerActions, dispatch),
    onSetLanguage: bindActionCreators(setLanguage, dispatch),
});

export default withAlert(connect(mapStateToProps, mapDispatchToProps)(EmailVerificationScreen));
